import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import './styles/theme.css';
import './styles/motion.css';
import { queryClient } from './api/queryClient';
import { AuthProvider } from './auth/AuthProvider';
import { Toaster } from './components/ui/sonner';
import { TooltipProvider } from './components/ui/tooltip';
import { configProblems } from './config';
import { applyStoredTheme } from './lib/theme';
import { router } from './router';
import { ConfigError } from './routes/ConfigError';

applyStoredTheme();
const missing = configProblems();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {missing.length > 0 ? (
      <ConfigError missing={missing} />
    ) : (
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <TooltipProvider>
            <RouterProvider router={router} />
          </TooltipProvider>
          <Toaster />
        </AuthProvider>
      </QueryClientProvider>
    )}
  </StrictMode>,
);
